import React, { useEffect, useState } from "react";
import api from "../lib/api";

// Shared festival fetcher — computed lunar dates + admin overrides.
export function useFestivals(limit = 60) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api
      .get(`/festivals?limit=${limit}`)
      .then((r) => alive && setItems(r.data || []))
      .catch(() => alive && setItems([]))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [limit]);

  return { items, loading };
}

export function festivalName(f, lang) {
  if (lang === "bn") return f.name_bn || f.name;
  if (lang === "hi") return f.name_hi || f.name;
  return f.name;
}

export function daysUntil(dateStr) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(`${dateStr}T00:00:00`);
  return Math.round((target - today) / 86400000);
}

export function formatFestivalDate(dateStr) {
  return new Date(`${dateStr}T00:00:00`).toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export default useFestivals;
